import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  badge: {
    display: 'flex',
    width: '36px',
    height: '36px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    color: theme.colors.white,
    fontSize: theme.typography.fontSizeSm,
    fontWeight: theme.typography.fontWeightBolder,
    '&.success': {
      backgroundColor: theme.colors.green,
    },
    '&.warning': {
      backgroundColor: theme.colors.orange,
    },
    '&.error': {
      backgroundColor: theme.status.errorColor,
    },
    '&.info': {
      backgroundColor: theme.status.infoColor,
    },
    '&.disabled': {
      backgroundColor: `var(--gameday-borders-borderColor, ${theme.borders.borderColor})`,
    },
  },
  label: {
    marginLeft: '10px',
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    fontSize: theme.typography.fontSizeSm,
  },
})

const Badge = ({ classes, className, label, value, variant }) => (
  <div className={cn(classes.root, className)}>
    <div className={cn(classes.badge, variant)}>{value}</div>
    {label && <span className={classes.label}>{label}</span>}
  </div>
)

Badge.defaultProps = {
  variant: 'success',
}

const BadgeComponent = withStyles(styles)(Badge)
BadgeComponent.displayName = 'Badge'
export default BadgeComponent
